import * as React from 'react'
import { Trans } from 'react-i18next'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat'
import { TOptions } from 'i18next'

interface TransLocoBaseProps {
  i18nKey: string
  components?: readonly React.ReactElement[] | { readonly [tagName: string]: React.ReactElement }
  values?: any
}

interface TransLocoWithT extends TransLocoBaseProps {
  t: TLocoType
  tICU?: never
}

interface TransLocoWithTICU extends TransLocoBaseProps {
  t?: never
  tICU: (
    assetKey: string,
    values: Record<string, PrimitiveType | FormatXMLElementFn<string>>,
    options?: TOptions,
  ) => any
}

export type TransLocoProps = TransLocoWithT | TransLocoWithTICU

const TransLoco = ({ t, tICU, i18nKey, components, values }: TransLocoProps) => {
  const translationFunction = tICU || t

  return (
    <Trans
      t={() => translationFunction(i18nKey, values)}
      i18nKey={i18nKey}
      components={components}
      values={values}
    />
  )
}

export default TransLoco
